import 'whatwg-fetch'
import {RaisedButton} from "material-ui";

const React = require('react');

const OCTOBER_MONTH_INDEX = 9; //show button to add for next year from october

export default class TopActionsComponent extends React.Component {
    render() {
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        return (
            <div>
                <RaisedButton
                    primary
                    label={"Adauga"}
                    style={{marginRight: '20px', marginBottom: '20px'}}
                    onClick={() => this.props.onAddClicked(false)}/>


                {currentMonth >= OCTOBER_MONTH_INDEX && <RaisedButton
                    primary
                    label={`Adauga ${currentYear + 1}`}
                    style={{marginRight: '20px', marginBottom: '20px'}}
                    onClick={() => this.props.onAddClicked(true)}/>}
            </div>

        );
    }
};